import http from "../pages/http-common";
import authHeader from "./auth-header";

const BASE = "/business";

const getAll = (owner) => {
  if (owner) return http.get(`${BASE}/${owner}`, { headers: authHeader() });
  return http.get(BASE, { headers: authHeader() });
};

const get = (id, owner) => {
  return http.get(`${BASE}/doc/${id}`, { headers: authHeader() })
    .catch(err => {
      if (owner) return http.get(`${BASE}/${owner}/${id}`, { headers: authHeader() });
      throw err;
    });
};

const create = (ownerOrData, maybeData) => {
  let owner;
  let payload;
  if (maybeData !== undefined) {
    owner = ownerOrData;
    payload = { ...maybeData, owner: maybeData.owner || owner };
  } else {
    payload = ownerOrData || {};
    owner = payload.owner;
  }
  if (owner) return http.post(`${BASE}/${owner}`, payload, { headers: authHeader() });
  return http.post(BASE, payload, { headers: authHeader() });
};

const update = (id, data, owner) => {
  return http.put(`${BASE}/doc/${id}`, data, { headers: authHeader() })
    .catch(err => {
      const target = owner || data?.owner;
      if (target) return http.put(`${BASE}/${target}/${id}`, data, { headers: authHeader() });
      throw err;
    });
};

const changeTenor = (id, data, owner) => {
  const target = owner || data?.owner;
  const endpoint = target ? `${BASE}/${target}/${id}/change-tenor` : `${BASE}/doc/${id}/change-tenor`;
  return http.put(endpoint, data, { headers: authHeader() });
};

const remove = (id, owner) => {
  if (owner) return http.delete(`${BASE}/${owner}/${id}`, { headers: authHeader() });
  return http.delete(`${BASE}/doc/${id}`, { headers: authHeader() });
};

const getSummary = (params) => {
  return http.get(`${BASE}/analytics/summary`, { headers: authHeader(), params });
};

const BusinessService = {
  getAll,
  get,
  getSummary,
  create,
  update,
  changeTenor,
  remove,
};

export default BusinessService;
